<section mat-dialog-title>
  <span class="test-title">{{ data.title }}</span>
  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>
<mat-dialog-content class="test-description">
  @if (data.showWarning) {
    <avs-message type="warning">
      {{ data.warningText || 'Be careful: once deleted, the data cannot be recovered.' }}
    </avs-message>
  }
  @if (data.template) {
    <ng-container *ngTemplateOutlet="data.template; context: data.templateContext" />
  } @else {
    <p
      class="text-ui-gray-100"
      [class]="isMobile() ? 'text-base font-medium' : 'text-left'"
    >
      {{ data.description }}
    </p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    class="test-btn-cancel btn-transparent btn-medium font-bold mr-4"
    mat-dialog-close
  >
    {{ data.cancelBtnText || 'No' }}
  </button>
  <button
    type="submit"
    class="btn-medium font-bold"
    [class.btn-green]="!data.isDeleteTypePopup"
    [class.btn-red]="data.isDeleteTypePopup"
    mat-dialog-close="true"
  >
    {{ data.confirmBtnText || 'Yes' }}
  </button>
</mat-dialog-actions>
